export default __webpack_public_path__ + "static/Hardware_con_api-b8ea3e6624a2834fb4b7299372980d06.png";